import React from 'react';
import { Criticidade } from '../models/atividade';
import { COR_CRITICIDADE, LABEL_CRITICIDADE } from '../utils/labels';

const RiscoBadge: React.FC<{ criticidade: Criticidade; rotulo?: string }> = ({ criticidade, rotulo }) => (
  <span className={`mc-risco mc-risco--${COR_CRITICIDADE[criticidade]}`}>{rotulo ?? LABEL_CRITICIDADE[criticidade]}</span>
);

export default RiscoBadge;
